if (!customElements.get('amm-clone-announcement-bar')) {
  class AmmCloneAnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.ammCloneController) return;

      this.ammCloneController = new AbortController();
      this.ammCloneSlides = Array.from(this.querySelectorAll('[data-amm-clone-slide]'));
      this.ammClonePrevious = this.querySelector('[data-amm-clone-previous]');
      this.ammCloneNext = this.querySelector('[data-amm-clone-next]');
      this.ammCloneViewport = this.querySelector('[data-amm-clone-viewport]');
      this.ammCloneIndex = Math.max(
        0,
        this.ammCloneSlides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.ammCloneReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ammCloneInterval = Math.max(3000, Number(this.dataset.ammCloneInterval) || 5000);
      this.ammCloneAutoRotate = this.dataset.ammCloneAutoRotate === 'true';
      this.ammClonePauseHover = this.dataset.ammClonePauseHover === 'true';
      this.ammCloneUpdateHeight = () => {
        document.documentElement.style.setProperty('--m-announcement-height', `${this.offsetHeight}px`);
      };
      this.ammCloneResizeObserver = new ResizeObserver(this.ammCloneUpdateHeight);
      this.ammCloneResizeObserver.observe(this);
      this.ammCloneUpdateHeight();

      const options = { signal: this.ammCloneController.signal };

      this.ammClonePrevious?.addEventListener('click', () => {
        this.ammCloneShow(this.ammCloneIndex - 1);
        this.ammCloneRestart();
      }, options);

      this.ammCloneNext?.addEventListener('click', () => {
        this.ammCloneShow(this.ammCloneIndex + 1);
        this.ammCloneRestart();
      }, options);

      this.ammCloneViewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.ammCloneShow(this.ammCloneIndex - 1);
          this.ammCloneRestart();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.ammCloneShow(this.ammCloneIndex + 1);
          this.ammCloneRestart();
        }
      }, options);

      if (this.ammClonePauseHover) {
        this.addEventListener('mouseenter', () => this.ammCloneStop(), options);
        this.addEventListener('mouseleave', () => this.ammCloneStart(), options);
        this.addEventListener('focusin', () => this.ammCloneStop(), options);
        this.addEventListener('focusout', () => this.ammCloneStart(), options);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.ammCloneStop();
        else this.ammCloneStart();
      }, options);

      this.ammCloneStart();
    }

    disconnectedCallback() {
      this.ammCloneStop();
      this.ammCloneResizeObserver?.disconnect();
      this.ammCloneController?.abort();
      this.ammCloneController = null;
    }

    ammCloneShow(index) {
      if (this.ammCloneSlides.length < 2) return;

      const nextIndex = (index + this.ammCloneSlides.length) % this.ammCloneSlides.length;
      if (nextIndex === this.ammCloneIndex) return;

      this.ammCloneSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.ammCloneIndex = nextIndex;
    }

    ammCloneStart() {
      if (
        !this.ammCloneAutoRotate ||
        this.ammCloneSlides.length < 2 ||
        this.ammCloneReducedMotion.matches ||
        document.hidden
      ) return;

      this.ammCloneStop();
      this.ammCloneTimer = window.setInterval(
        () => this.ammCloneShow(this.ammCloneIndex + 1),
        this.ammCloneInterval
      );
    }

    ammCloneStop() {
      if (!this.ammCloneTimer) return;
      window.clearInterval(this.ammCloneTimer);
      this.ammCloneTimer = null;
    }

    ammCloneRestart() {
      this.ammCloneStop();
      this.ammCloneStart();
    }
  }

  customElements.define('amm-clone-announcement-bar', AmmCloneAnnouncementBar);
}
